import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { ReactElement } from "react";
import { createRoot } from "react-dom/client";
import { toZonedTime } from 'date-fns-tz'
import {setHours, setMinutes } from 'date-fns'

export const generatePDF = async (Component: ReactElement, fileName = "document.pdf") => {
    // Create a hidden container for rendering the component
    const tempDiv = document.createElement("div");
    tempDiv.style.position = "absolute";
    tempDiv.style.left = "-9999px";
    tempDiv.style.top = "-9999px";
    tempDiv.style.width = "100%";
    tempDiv.style.padding = "20px";
    tempDiv.style.background = "white";
    document.body.appendChild(tempDiv);

    // Render the React component inside the hidden div
    const root = createRoot(tempDiv);
    root.render(Component);

    // Wait for rendering before capturing
    await new Promise((resolve) => setTimeout(resolve, 500));

    // Capture the component as an image
    const canvas = await html2canvas(tempDiv, { scale: 2, useCORS: true }); // Scale 2 for sharper images
    const imgData = canvas.toDataURL("image/png");

    // Generate PDF
    const pdf = new jsPDF("p", "mm", "a4");
    const imgWidth = 210;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    pdf.addImage(imgData, "PNG", 0, 10, imgWidth, imgHeight);
    pdf.save(fileName);

    // Cleanup
    root.unmount();
    document.body.removeChild(tempDiv);
};

export enum CheckTimeType {
    CHECKIN = 'CHECKIN',
    CHECKOUT = 'CHECKOUT'
}

const timeZone = process.env.NEXT_PUBLIC_TIME_ZONE;

export const refactorDate = (date: Date, type: CheckTimeType): Date => {
    // const offsetMinutes = 5 * 60 + 30;
    // let newDate: Date;

    // if (type === CheckTimeType.CHECKIN) {
    //     newDate = setMinutes(setHours(date, 0), 0);
    // } else {
    //     newDate = setMinutes(setHours(date, 23), 59);
    // }

    // return new Date(newDate.getTime() + offsetMinutes * 60 * 1000);

    if (type === CheckTimeType.CHECKIN) {
        return toZonedTime(setMinutes(setHours(date, 0), 0), timeZone!);
    } else {
        return toZonedTime(setMinutes(setHours(date, 23), 59), timeZone!);
    }
};
